/**
 * Created by mac on 2018/8/23.
 */
/**
 * Created by mac on 2018/8/14.
 */
import Modal from '@/components/Modal/';
import loadingImg from '@/assets/images/img_binding_pic.png';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import { Global } from '../../constants/actionTypes';
import {
  setBindPhoneStatus,
  setBindWxStatus,
} from '../../actions/GlobalAction';
import IconFont from '../Icon/IconFont';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';
import styles from './HasOtherAccount.scss';
@connect(
  (state) => {
    const globalState = getGlobalState(state);
    return {
      data: globalState.get('account'),
      content: globalState.get('occupyhasother').msg,
    };
  },
  dispatch => ({
    setBindPhoneStatus: status => dispatch(setBindPhoneStatus(status)),
  }),
)
export default class HasOtherAccount extends Component {
  static goUrl() {
    const url = window.location.href;
    window.location.href = `/users/auth/wechat?transfer=true&redirect_url=${encodeURIComponent(url)}`;
  }
  render() {
    const { onModalCancelClick, visible, data } = this.props;
    return (
      <Modal
        width={520}
        visible={visible}
        showFooter={false}
        closable
        isMiddle
        title={i18n.get('phoneModal.wxoccupy')}
        onCancel={onModalCancelClick}
      >
        <div className={styles.content}>
          <p>{this.props.content}</p>
          <button
            className={styles['btn']}
            onClick={() => {
            HasOtherAccount.goUrl();
          }}
          >{i18n.get('phoneModal.yjjb')}
          </button>
          <span className={styles['cancel']} onClick={onModalCancelClick}>{i18n.get('phoneModal.cancel')}</span>
        </div>
      </Modal>);
  }
}



// WEBPACK FOOTER //
// ./src/components/HasBindMordal/HasOtherAccount.js